import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { TUTORIALS_LINK } from "../../constants/CommonConstants"
import { Badge } from '@mui/material'; 
import { useEffect } from 'react';

export default function SettingMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isNotificationHidden, setIsNotificationHidden] = React.useState(props.isNotificationHidden);

    useEffect(() => {
        setIsNotificationHidden(props.isNotificationHidden);
    }, [props.isNotificationHidden]);

    const styleNotification = {
        "&": {
            display: "block",
        },
        "& .MuiBadge-dot": {
            top: "10px",
            left: "8px",
        },
    };

    const handleSettingClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const dialog = (open) => {
        setAnchorEl(null);
        open();
    }

    const linkToTutorialSite = () => {
        setAnchorEl(null);
        const tutorialsLink = TUTORIALS_LINK[process.env.REACT_APP_BUILD_ENV];
        window.open(tutorialsLink, "_blank");
        if(!isNotificationHidden){
            updateLoginCEUserInfo();
        }
    };

    const updateLoginCEUserInfo = () => {
        let header = {
            'Authorization': localStorage.getItem('ceAuthorization'),
            'Content-Type': 'application/json'
        };
        fetch(process.env.REACT_APP_CE_ACCOUNT, {
            method: "PUT",
            headers: header,
            body: JSON.stringify({
                authToken:"",
                target:"tutorial"
            })
        }).then(res => {
            if(res.ok){
                setIsNotificationHidden(true);
            }
        }).catch((e) => {
            console.log("eeeeee",e)
        })
    }

    return (
        <div>
            <Button aria-controls="ceSimple-menu" aria-haspopup="true" onClick={handleSettingClick} >
                <div className={isNotificationHidden ? "ce-notificationIcon-hidden" : "ce-notificationIcon-show"}></div>
                <img id="ceSetupButton" src="/assets/img/btn_setup_n.svg" alt="setup" />            
            </Button>

            <Menu
                id="ceSimple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                elevation={0}
                getContentAnchorEl={null}
                anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
                }}
                transformOrigin={{
                vertical: "top",
                horizontal: "center"
                }}
            >
                <MenuItem onClick={() => dialog(props.changeLanguage)}>{props.intl.formatMessage({ id: "change_language" })}</MenuItem>
                <MenuItem onClick={() => dialog(props.changePassword)}>{props.intl.formatMessage({ id: "header_change_password" })}</MenuItem>
                <div style={{height:"1px", margin:"0 2.5px", borderTop:"1px solid #929090"}}></div>
                <Badge color="error" variant="dot" invisible={isNotificationHidden} anchorOrigin={{vertical: 'bottom',horizontal: 'left',}} sx={styleNotification}>
                    <MenuItem onClick={() => linkToTutorialSite()}>{props.intl.formatMessage({ id: "header_settingMenu_tutorial" })}</MenuItem>
                </Badge>
                <MenuItem onClick={() => dialog(props.versionInfo)}>{props.intl.formatMessage({ id: "header_settingMenu_version" })}</MenuItem>
            </Menu>
        </div>
    );
}